import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        wrapper: {
            width: '100%',
            height: '100%',
            margin: theme.spacing(0.25),
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(0.25),
            alignItems: 'center',
        },
        chip: {
            display: 'inline-block',
            background: theme.palette.secondary[200],
            fontSize: theme.typography.button.fontSize,
            verticalAlign: 'middle',
            borderRadius: 18,
            color: theme.palette.secondary[800],
            padding: theme.spacing(1),
            margin: `${theme.spacing(0.2)} ${theme.spacing(0.2)} 0 0`,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: 'fill-available',
        },
    }
})

export default useStyles
